import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '../store'
import { ElMessage } from 'element-plus'
import { createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/doctor',
    name: 'doctor',
    component: () => import(/* webpackChunkName: "doctor" */ '../views/DoctorView.vue'),
    meta: {
      requiresAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/patient',
    name: 'patient',
    component: () => import(/* webpackChunkName: "patient" */ '../views/PatientView.vue'),
    meta: {
      requiresAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/case',
    name: 'case',
    component: () => import(/* webpackChunkName: "case" */ '../views/CaseView.vue'),
    meta: {
      requiresAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/report',
    name: 'report',
    component: () => import(/* webpackChunkName: "report" */ '../views/ReportView.vue'),
    meta: {
      requiresAuth: true // 需要登录才能访问
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  // 检查是否需要登录权限
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查是否已登录
    if (store.getters.isLogin) {
      try {
        // 验证token是否有效（可选，如果后端支持）
        // const isValid = await store.dispatch('validateToken')
        // if (isValid) {
        //   next()
        // } else {
        //   ElMessage.error('登录已过期，请重新登录')
        //   next('/')
        // }
        
        // 简单验证：只要有token就认为已登录
        next()
      } catch (error) {
        console.error('验证登录状态失败:', error)
        ElMessage.error('验证登录状态失败')
        next('/')
      }
    } else {
      // 未登录，跳转到首页或登录页
      ElMessage.warning('请先登录')
      next('/')
    }
  } else {
    // 不需要登录权限的页面直接放行
    next()
  }
})

// 全局后置钩子
router.afterEach((to, from) => {
  // 可以在这里添加页面标题设置等
  console.log(`导航到: ${to.name}`)
})

export default router
